// extracted by mini-css-extract-plugin
export default {"list-wrapper":"Packs_list-wrapper__gK2ow","list":"Packs_list__tpYa9"};